// @generated by protoc-gen-es v2.11.0 with parameter "target=ts+js"
// @generated from file lease/merchant/v1/api.proto (package lease.merchant.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_field_behavior } from "../google/api/field_behavior_pb";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_lease_common_v1_types } from "../common/v1/types_pb";
import { file_lease_kiosk_v1_virtual_products } from "../kiosk/v1/virtual_products_pb";

/**
 * Describes the file lease/merchant/v1/api.proto.
 */
export const file_lease_merchant_v1_api = /*@__PURE__*/
  fileDesc("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", [file_google_api_field_behavior, file_google_protobuf_timestamp, file_lease_common_v1_types, file_lease_kiosk_v1_virtual_products]);

/**
 * Describes the message lease.merchant.v1.RefundRequest.
 * Use `create(RefundRequestSchema)` to create a new message.
 */
export const RefundRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 0);

/**
 * Describes the message lease.merchant.v1.RefundResponse.
 * Use `create(RefundResponseSchema)` to create a new message.
 */
export const RefundResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 1);

/**
 * Describes the message lease.merchant.v1.ListCustomersRequest.
 * Use `create(ListCustomersRequestSchema)` to create a new message.
 */
export const ListCustomersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 2);

/**
 * Describes the message lease.merchant.v1.ListCustomersResponse.
 * Use `create(ListCustomersResponseSchema)` to create a new message.
 */
export const ListCustomersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 3);

/**
 * Describes the message lease.merchant.v1.Customer.
 * Use `create(CustomerSchema)` to create a new message.
 */
export const CustomerSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 4);

/**
 * Describes the message lease.merchant.v1.ListProductsRequest.
 * Use `create(ListProductsRequestSchema)` to create a new message.
 */
export const ListProductsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 5);

/**
 * Describes the message lease.merchant.v1.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 6);

/**
 * Describes the message lease.merchant.v1.ListProductsResponse.
 * Use `create(ListProductsResponseSchema)` to create a new message.
 */
export const ListProductsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 7);

/**
 * Describes the message lease.merchant.v1.ListProductTrackableItemsRequest.
 * Use `create(ListProductTrackableItemsRequestSchema)` to create a new message.
 */
export const ListProductTrackableItemsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 8);

/**
 * Describes the message lease.merchant.v1.TrackableItemLocation.
 * Use `create(TrackableItemLocationSchema)` to create a new message.
 */
export const TrackableItemLocationSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 9);

/**
 * Describes the message lease.merchant.v1.TrackableItem.
 * Use `create(TrackableItemSchema)` to create a new message.
 */
export const TrackableItemSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 10);

/**
 * Describes the message lease.merchant.v1.ListProductTrackableItemsResponse.
 * Use `create(ListProductTrackableItemsResponseSchema)` to create a new message.
 */
export const ListProductTrackableItemsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 11);

/**
 * Describes the message lease.merchant.v1.UpdateProductRequest.
 * Use `create(UpdateProductRequestSchema)` to create a new message.
 */
export const UpdateProductRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 12);

/**
 * Describes the message lease.merchant.v1.UpdateProductResponse.
 * Use `create(UpdateProductResponseSchema)` to create a new message.
 */
export const UpdateProductResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 13);

/**
 * Describes the message lease.merchant.v1.CreateProductRequest.
 * Use `create(CreateProductRequestSchema)` to create a new message.
 */
export const CreateProductRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 14);

/**
 * Describes the message lease.merchant.v1.CreateProductResponse.
 * Use `create(CreateProductResponseSchema)` to create a new message.
 */
export const CreateProductResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 15);

/**
 * Describes the message lease.merchant.v1.CreateTrackableItemRequest.
 * Use `create(CreateTrackableItemRequestSchema)` to create a new message.
 */
export const CreateTrackableItemRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 16);

/**
 * Describes the message lease.merchant.v1.CreateTrackableItemResponse.
 * Use `create(CreateTrackableItemResponseSchema)` to create a new message.
 */
export const CreateTrackableItemResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 17);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemRequest.
 * Use `create(UpdateTrackableItemRequestSchema)` to create a new message.
 */
export const UpdateTrackableItemRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 18);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemResponse.
 * Use `create(UpdateTrackableItemResponseSchema)` to create a new message.
 */
export const UpdateTrackableItemResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 19);

/**
 * Describes the message lease.merchant.v1.ArchiveProductRequest.
 * Use `create(ArchiveProductRequestSchema)` to create a new message.
 */
export const ArchiveProductRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 20);

/**
 * Describes the message lease.merchant.v1.ArchiveProductResponse.
 * Use `create(ArchiveProductResponseSchema)` to create a new message.
 */
export const ArchiveProductResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 21);

/**
 * Describes the message lease.merchant.v1.ListMachinesRequest.
 * Use `create(ListMachinesRequestSchema)` to create a new message.
 */
export const ListMachinesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 22);

/**
 * Describes the message lease.merchant.v1.MachineInfo.
 * Use `create(MachineInfoSchema)` to create a new message.
 */
export const MachineInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 23);

/**
 * Describes the message lease.merchant.v1.ListMachinesResponse.
 * Use `create(ListMachinesResponseSchema)` to create a new message.
 */
export const ListMachinesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 24);

/**
 * Describes the message lease.merchant.v1.ListMachineProductMapsRequest.
 * Use `create(ListMachineProductMapsRequestSchema)` to create a new message.
 */
export const ListMachineProductMapsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 25);

/**
 * Describes the message lease.merchant.v1.ProductMap.
 * Use `create(ProductMapSchema)` to create a new message.
 */
export const ProductMapSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 26);

/**
 * Describes the message lease.merchant.v1.ListMachineProductMapsResponse.
 * Use `create(ListMachineProductMapsResponseSchema)` to create a new message.
 */
export const ListMachineProductMapsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 27);

/**
 * Describes the message lease.merchant.v1.ListOrdersRequest.
 * Use `create(ListOrdersRequestSchema)` to create a new message.
 */
export const ListOrdersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 28);

/**
 * Describes the message lease.merchant.v1.Order.
 * Use `create(OrderSchema)` to create a new message.
 */
export const OrderSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 29);

/**
 * Describes the message lease.merchant.v1.RefundStatus.
 * Use `create(RefundStatusSchema)` to create a new message.
 */
export const RefundStatusSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 30);

/**
 * Describes the message lease.merchant.v1.ListOrdersResponse.
 * Use `create(ListOrdersResponseSchema)` to create a new message.
 */
export const ListOrdersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 31);

/**
 * Describes the message lease.merchant.v1.ListCustomerOrdersRequest.
 * Use `create(ListCustomerOrdersRequestSchema)` to create a new message.
 */
export const ListCustomerOrdersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 32);

/**
 * Describes the message lease.merchant.v1.ListCustomerOrdersResponse.
 * Use `create(ListCustomerOrdersResponseSchema)` to create a new message.
 */
export const ListCustomerOrdersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 33);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemStateRequest.
 * Use `create(UpdateTrackableItemStateRequestSchema)` to create a new message.
 */
export const UpdateTrackableItemStateRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 34);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemStateResponse.
 * Use `create(UpdateTrackableItemStateResponseSchema)` to create a new message.
 */
export const UpdateTrackableItemStateResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 35);

/**
 * Describes the message lease.merchant.v1.OpenDoorsRequest.
 * Use `create(OpenDoorsRequestSchema)` to create a new message.
 */
export const OpenDoorsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 36);

/**
 * Describes the message lease.merchant.v1.OpenDoorsResponse.
 * Use `create(OpenDoorsResponseSchema)` to create a new message.
 */
export const OpenDoorsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 37);

/**
 * Describes the message lease.merchant.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 38);

/**
 * Describes the message lease.merchant.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 39);

/**
 * Describes the message lease.merchant.v1.AccessibleOrganization.
 * Use `create(AccessibleOrganizationSchema)` to create a new message.
 */
export const AccessibleOrganizationSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 40);

/**
 * Describes the message lease.merchant.v1.GetStatsRequest.
 * Use `create(GetStatsRequestSchema)` to create a new message.
 */
export const GetStatsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 41);

/**
 * Describes the message lease.merchant.v1.GetStatsResponse.
 * Use `create(GetStatsResponseSchema)` to create a new message.
 */
export const GetStatsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 42);

/**
 * Describes the message lease.merchant.v1.Stats.
 * Use `create(StatsSchema)` to create a new message.
 */
export const StatsSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 43);

/**
 * Describes the message lease.merchant.v1.PaymentInformation.
 * Use `create(PaymentInformationSchema)` to create a new message.
 */
export const PaymentInformationSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 44);

/**
 * Describes the message lease.merchant.v1.GetMyOrganizationInfoRequest.
 * Use `create(GetMyOrganizationInfoRequestSchema)` to create a new message.
 */
export const GetMyOrganizationInfoRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 45);

/**
 * Describes the message lease.merchant.v1.OrganizationInfo.
 * Use `create(OrganizationInfoSchema)` to create a new message.
 */
export const OrganizationInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 46);

/**
 * Describes the message lease.merchant.v1.GetMyOrganizationInfoResponse.
 * Use `create(GetMyOrganizationInfoResponseSchema)` to create a new message.
 */
export const GetMyOrganizationInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 47);

/**
 * Describes the message lease.merchant.v1.UpdateOrganizationInfoRequest.
 * Use `create(UpdateOrganizationInfoRequestSchema)` to create a new message.
 */
export const UpdateOrganizationInfoRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 48);

/**
 * Describes the message lease.merchant.v1.UpdateOrganizationInfoResponse.
 * Use `create(UpdateOrganizationInfoResponseSchema)` to create a new message.
 */
export const UpdateOrganizationInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 49);

/**
 * Describes the message lease.merchant.v1.GetMyInfoRequest.
 * Use `create(GetMyInfoRequestSchema)` to create a new message.
 */
export const GetMyInfoRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 50);

/**
 * Describes the message lease.merchant.v1.UserInfo.
 * Use `create(UserInfoSchema)` to create a new message.
 */
export const UserInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 51);

/**
 * Describes the message lease.merchant.v1.GetMyInfoResponse.
 * Use `create(GetMyInfoResponseSchema)` to create a new message.
 */
export const GetMyInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 52);

/**
 * Describes the message lease.merchant.v1.UpdateVendingMachineRequest.
 * Use `create(UpdateVendingMachineRequestSchema)` to create a new message.
 */
export const UpdateVendingMachineRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 53);

/**
 * Describes the message lease.merchant.v1.UpdateVendingMachineResponse.
 * Use `create(UpdateVendingMachineResponseSchema)` to create a new message.
 */
export const UpdateVendingMachineResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 54);

/**
 * Describes the message lease.merchant.v1.CaptureOrderRequest.
 * Use `create(CaptureOrderRequestSchema)` to create a new message.
 */
export const CaptureOrderRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 55);

/**
 * Describes the message lease.merchant.v1.CaptureOrderResponse.
 * Use `create(CaptureOrderResponseSchema)` to create a new message.
 */
export const CaptureOrderResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 56);

/**
 * Describes the message lease.merchant.v1.VoidOrderRequest.
 * Use `create(VoidOrderRequestSchema)` to create a new message.
 */
export const VoidOrderRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 57);

/**
 * Describes the message lease.merchant.v1.VoidOrderResponse.
 * Use `create(VoidOrderResponseSchema)` to create a new message.
 */
export const VoidOrderResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 58);

/**
 * Describes the message lease.merchant.v1.GetUploadUrlRequest.
 * Use `create(GetUploadUrlRequestSchema)` to create a new message.
 */
export const GetUploadUrlRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 59);

/**
 * Describes the message lease.merchant.v1.GetUploadUrlResponse.
 * Use `create(GetUploadUrlResponseSchema)` to create a new message.
 */
export const GetUploadUrlResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 60);

/**
 * Describes the message lease.merchant.v1.UpdateProductMapRequest.
 * Use `create(UpdateProductMapRequestSchema)` to create a new message.
 */
export const UpdateProductMapRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 61);

/**
 * Describes the message lease.merchant.v1.UpdateProductMapResponse.
 * Use `create(UpdateProductMapResponseSchema)` to create a new message.
 */
export const UpdateProductMapResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 62);

/**
 * Describes the message lease.merchant.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 63);

/**
 * Describes the message lease.merchant.v1.SendEventToMachineRequest.
 * Use `create(SendEventToMachineRequestSchema)` to create a new message.
 */
export const SendEventToMachineRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 64);

/**
 * Describes the message lease.merchant.v1.SendEventToMachineResponse.
 * Use `create(SendEventToMachineResponseSchema)` to create a new message.
 */
export const SendEventToMachineResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 65);

/**
 * Describes the message lease.merchant.v1.OrderDailySummariesRequest.
 * Use `create(OrderDailySummariesRequestSchema)` to create a new message.
 */
export const OrderDailySummariesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 66);

/**
 * Describes the message lease.merchant.v1.OrderDailySummary.
 * Use `create(OrderDailySummarySchema)` to create a new message.
 */
export const OrderDailySummarySchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 67);

/**
 * Describes the message lease.merchant.v1.OrderDailySummariesResponse.
 * Use `create(OrderDailySummariesResponseSchema)` to create a new message.
 */
export const OrderDailySummariesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 68);

/**
 * Describes the message lease.merchant.v1.ListCellOrdersRequest.
 * Use `create(ListCellOrdersRequestSchema)` to create a new message.
 */
export const ListCellOrdersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 69);

/**
 * Describes the message lease.merchant.v1.ListCellOrdersResponse.
 * Use `create(ListCellOrdersResponseSchema)` to create a new message.
 */
export const ListCellOrdersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 70);

/**
 * Describes the message lease.merchant.v1.GetCustomerAuthLogsRequest.
 * Use `create(GetCustomerAuthLogsRequestSchema)` to create a new message.
 */
export const GetCustomerAuthLogsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 71);

/**
 * Describes the message lease.merchant.v1.AuthLog.
 * Use `create(AuthLogSchema)` to create a new message.
 */
export const AuthLogSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 72);

/**
 * Describes the message lease.merchant.v1.GetCustomerAuthLogsResponse.
 * Use `create(GetCustomerAuthLogsResponseSchema)` to create a new message.
 */
export const GetCustomerAuthLogsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 73);

/**
 * Describes the message lease.merchant.v1.GetCustomerSMSDeliveryStatusRequest.
 * Use `create(GetCustomerSMSDeliveryStatusRequestSchema)` to create a new message.
 */
export const GetCustomerSMSDeliveryStatusRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 74);

/**
 * Describes the message lease.merchant.v1.SMSDeliveryStatus.
 * Use `create(SMSDeliveryStatusSchema)` to create a new message.
 */
export const SMSDeliveryStatusSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 75);

/**
 * Describes the message lease.merchant.v1.GetCustomerSMSDeliveryStatusResponse.
 * Use `create(GetCustomerSMSDeliveryStatusResponseSchema)` to create a new message.
 */
export const GetCustomerSMSDeliveryStatusResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 76);

/**
 * Describes the message lease.merchant.v1.SendSMSToCustomerRequest.
 * Use `create(SendSMSToCustomerRequestSchema)` to create a new message.
 */
export const SendSMSToCustomerRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 77);

/**
 * Describes the message lease.merchant.v1.SendSMSToCustomerResponse.
 * Use `create(SendSMSToCustomerResponseSchema)` to create a new message.
 */
export const SendSMSToCustomerResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 78);

/**
 * Describes the message lease.merchant.v1.VenueAccessCodeConfig.
 * Use `create(VenueAccessCodeConfigSchema)` to create a new message.
 */
export const VenueAccessCodeConfigSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 79);

/**
 * Describes the message lease.merchant.v1.VenueAccessCode.
 * Use `create(VenueAccessCodeSchema)` to create a new message.
 */
export const VenueAccessCodeSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 80);

/**
 * Describes the message lease.merchant.v1.ListVenueAccessCodesRequest.
 * Use `create(ListVenueAccessCodesRequestSchema)` to create a new message.
 */
export const ListVenueAccessCodesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 81);

/**
 * Describes the message lease.merchant.v1.ListVenueAccessCodesResponse.
 * Use `create(ListVenueAccessCodesResponseSchema)` to create a new message.
 */
export const ListVenueAccessCodesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 82);

/**
 * Describes the message lease.merchant.v1.CreateVenueAccessCodesRequest.
 * Use `create(CreateVenueAccessCodesRequestSchema)` to create a new message.
 */
export const CreateVenueAccessCodesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 83);

/**
 * Describes the message lease.merchant.v1.CreateVenueAccessCodesResponse.
 * Use `create(CreateVenueAccessCodesResponseSchema)` to create a new message.
 */
export const CreateVenueAccessCodesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 84);

/**
 * Describes the message lease.merchant.v1.DeleteVenueAccessCodeRequest.
 * Use `create(DeleteVenueAccessCodeRequestSchema)` to create a new message.
 */
export const DeleteVenueAccessCodeRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 85);

/**
 * Describes the message lease.merchant.v1.DeleteVenueAccessCodeResponse.
 * Use `create(DeleteVenueAccessCodeResponseSchema)` to create a new message.
 */
export const DeleteVenueAccessCodeResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 86);

/**
 * Describes the message lease.merchant.v1.GetVenueAccessCodeUsageRequest.
 * Use `create(GetVenueAccessCodeUsageRequestSchema)` to create a new message.
 */
export const GetVenueAccessCodeUsageRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 87);

/**
 * Describes the message lease.merchant.v1.VenueAccessCodeUsageStats.
 * Use `create(VenueAccessCodeUsageStatsSchema)` to create a new message.
 */
export const VenueAccessCodeUsageStatsSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 88);

/**
 * Describes the message lease.merchant.v1.VenueAccessCodeUsage.
 * Use `create(VenueAccessCodeUsageSchema)` to create a new message.
 */
export const VenueAccessCodeUsageSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 89);

/**
 * Describes the message lease.merchant.v1.GetVenueAccessCodeUsageResponse.
 * Use `create(GetVenueAccessCodeUsageResponseSchema)` to create a new message.
 */
export const GetVenueAccessCodeUsageResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 90);

/**
 * Describes the message lease.merchant.v1.AuthConfiguration.
 * Use `create(AuthConfigurationSchema)` to create a new message.
 */
export const AuthConfigurationSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 91);

/**
 * Describes the message lease.merchant.v1.GetAuthConfigurationRequest.
 * Use `create(GetAuthConfigurationRequestSchema)` to create a new message.
 */
export const GetAuthConfigurationRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 92);

/**
 * Describes the message lease.merchant.v1.GetAuthConfigurationResponse.
 * Use `create(GetAuthConfigurationResponseSchema)` to create a new message.
 */
export const GetAuthConfigurationResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 93);

/**
 * Describes the message lease.merchant.v1.UpdateAuthConfigurationRequest.
 * Use `create(UpdateAuthConfigurationRequestSchema)` to create a new message.
 */
export const UpdateAuthConfigurationRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 94);

/**
 * Describes the message lease.merchant.v1.UpdateAuthConfigurationResponse.
 * Use `create(UpdateAuthConfigurationResponseSchema)` to create a new message.
 */
export const UpdateAuthConfigurationResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 95);

/**
 * Describes the message lease.merchant.v1.ListMachineActuatorsRequest.
 * Use `create(ListMachineActuatorsRequestSchema)` to create a new message.
 */
export const ListMachineActuatorsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 96);

/**
 * Describes the message lease.merchant.v1.ActuatorInfo.
 * Use `create(ActuatorInfoSchema)` to create a new message.
 */
export const ActuatorInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 97);

/**
 * Describes the message lease.merchant.v1.ListMachineActuatorsResponse.
 * Use `create(ListMachineActuatorsResponseSchema)` to create a new message.
 */
export const ListMachineActuatorsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 98);

/**
 * Describes the message lease.merchant.v1.UpdateMachineActuatorRequest.
 * Use `create(UpdateMachineActuatorRequestSchema)` to create a new message.
 */
export const UpdateMachineActuatorRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 99);

/**
 * Describes the message lease.merchant.v1.UpdateMachineActuatorResponse.
 * Use `create(UpdateMachineActuatorResponseSchema)` to create a new message.
 */
export const UpdateMachineActuatorResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 100);

/**
 * Describes the message lease.merchant.v1.CreateMachineActuatorRequest.
 * Use `create(CreateMachineActuatorRequestSchema)` to create a new message.
 */
export const CreateMachineActuatorRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 101);

/**
 * Describes the message lease.merchant.v1.CreateMachineActuatorResponse.
 * Use `create(CreateMachineActuatorResponseSchema)` to create a new message.
 */
export const CreateMachineActuatorResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 102);

/**
 * Describes the message lease.merchant.v1.DeleteMachineActuatorRequest.
 * Use `create(DeleteMachineActuatorRequestSchema)` to create a new message.
 */
export const DeleteMachineActuatorRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 103);

/**
 * Describes the message lease.merchant.v1.DeleteMachineActuatorResponse.
 * Use `create(DeleteMachineActuatorResponseSchema)` to create a new message.
 */
export const DeleteMachineActuatorResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 104);

/**
 * Describes the message lease.merchant.v1.GetDoorStatusHistoryRequest.
 * Use `create(GetDoorStatusHistoryRequestSchema)` to create a new message.
 */
export const GetDoorStatusHistoryRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 105);

/**
 * Describes the message lease.merchant.v1.GetDoorStatusHistoryResponse.
 * Use `create(GetDoorStatusHistoryResponseSchema)` to create a new message.
 */
export const GetDoorStatusHistoryResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 106);

/**
 * Describes the message lease.merchant.v1.DoorStatusHistoryEntry.
 * Use `create(DoorStatusHistoryEntrySchema)` to create a new message.
 */
export const DoorStatusHistoryEntrySchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 107);

/**
 * Describes the message lease.merchant.v1.GetMachineUptimeRequest.
 * Use `create(GetMachineUptimeRequestSchema)` to create a new message.
 */
export const GetMachineUptimeRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 108);

/**
 * Describes the message lease.merchant.v1.GetMachineUptimeResponse.
 * Use `create(GetMachineUptimeResponseSchema)` to create a new message.
 */
export const GetMachineUptimeResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 109);

/**
 * Describes the message lease.merchant.v1.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 110);

/**
 * Describes the message lease.merchant.v1.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 111);

/**
 * Describes the message lease.merchant.v1.UpdateUserStatusRequest.
 * Use `create(UpdateUserStatusRequestSchema)` to create a new message.
 */
export const UpdateUserStatusRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 112);

/**
 * Describes the message lease.merchant.v1.UpdateUserStatusResponse.
 * Use `create(UpdateUserStatusResponseSchema)` to create a new message.
 */
export const UpdateUserStatusResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 113);

/**
 * Describes the message lease.merchant.v1.ResetUserPasswordRequest.
 * Use `create(ResetUserPasswordRequestSchema)` to create a new message.
 */
export const ResetUserPasswordRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 114);

/**
 * Describes the message lease.merchant.v1.ResetUserPasswordResponse.
 * Use `create(ResetUserPasswordResponseSchema)` to create a new message.
 */
export const ResetUserPasswordResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 115);

/**
 * Describes the message lease.merchant.v1.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 116);

/**
 * Describes the message lease.merchant.v1.CreateUserResponse.
 * Use `create(CreateUserResponseSchema)` to create a new message.
 */
export const CreateUserResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 117);

/**
 * Describes the message lease.merchant.v1.RequestPasswordResetRequest.
 * Use `create(RequestPasswordResetRequestSchema)` to create a new message.
 */
export const RequestPasswordResetRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 118);

/**
 * Describes the message lease.merchant.v1.RequestPasswordResetResponse.
 * Use `create(RequestPasswordResetResponseSchema)` to create a new message.
 */
export const RequestPasswordResetResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 119);

/**
 * Describes the message lease.merchant.v1.ResetPasswordWithTokenRequest.
 * Use `create(ResetPasswordWithTokenRequestSchema)` to create a new message.
 */
export const ResetPasswordWithTokenRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 120);

/**
 * Describes the message lease.merchant.v1.ResetPasswordWithTokenResponse.
 * Use `create(ResetPasswordWithTokenResponseSchema)` to create a new message.
 */
export const ResetPasswordWithTokenResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 121);

/**
 * Describes the message lease.merchant.v1.ChangePasswordRequest.
 * Use `create(ChangePasswordRequestSchema)` to create a new message.
 */
export const ChangePasswordRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 122);

/**
 * Describes the message lease.merchant.v1.ChangePasswordResponse.
 * Use `create(ChangePasswordResponseSchema)` to create a new message.
 */
export const ChangePasswordResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 123);

/**
 * Describes the message lease.merchant.v1.AuditLog.
 * Use `create(AuditLogSchema)` to create a new message.
 */
export const AuditLogSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 124);

/**
 * Describes the message lease.merchant.v1.ListAuditLogsRequest.
 * Use `create(ListAuditLogsRequestSchema)` to create a new message.
 */
export const ListAuditLogsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 125);

/**
 * Describes the message lease.merchant.v1.ListAuditLogsResponse.
 * Use `create(ListAuditLogsResponseSchema)` to create a new message.
 */
export const ListAuditLogsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 126);

/**
 * Describes the message lease.merchant.v1.VirtualProductConfig.
 * Use `create(VirtualProductConfigSchema)` to create a new message.
 */
export const VirtualProductConfigSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 127);

/**
 * Describes the message lease.merchant.v1.TestVirtualProductConfigRequest.
 * Use `create(TestVirtualProductConfigRequestSchema)` to create a new message.
 */
export const TestVirtualProductConfigRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 128);

/**
 * Describes the message lease.merchant.v1.TestVirtualProductConfigResponse.
 * Use `create(TestVirtualProductConfigResponseSchema)` to create a new message.
 */
export const TestVirtualProductConfigResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 129);

/**
 * Describes the message lease.merchant.v1.PreviewVirtualProductsRequest.
 * Use `create(PreviewVirtualProductsRequestSchema)` to create a new message.
 */
export const PreviewVirtualProductsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 130);

/**
 * Describes the message lease.merchant.v1.PreviewVirtualProductsResponse.
 * Use `create(PreviewVirtualProductsResponseSchema)` to create a new message.
 */
export const PreviewVirtualProductsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 131);

/**
 * Describes the message lease.merchant.v1.NativeVirtualProductCategory.
 * Use `create(NativeVirtualProductCategorySchema)` to create a new message.
 */
export const NativeVirtualProductCategorySchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 132);

/**
 * Describes the message lease.merchant.v1.NativeVirtualProductVariant.
 * Use `create(NativeVirtualProductVariantSchema)` to create a new message.
 */
export const NativeVirtualProductVariantSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 133);

/**
 * Describes the message lease.merchant.v1.ListNativeCategoriesRequest.
 * Use `create(ListNativeCategoriesRequestSchema)` to create a new message.
 */
export const ListNativeCategoriesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 134);

/**
 * Describes the message lease.merchant.v1.ListNativeCategoriesResponse.
 * Use `create(ListNativeCategoriesResponseSchema)` to create a new message.
 */
export const ListNativeCategoriesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 135);

/**
 * Describes the message lease.merchant.v1.CreateNativeCategoryRequest.
 * Use `create(CreateNativeCategoryRequestSchema)` to create a new message.
 */
export const CreateNativeCategoryRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 136);

/**
 * Describes the message lease.merchant.v1.CreateNativeCategoryResponse.
 * Use `create(CreateNativeCategoryResponseSchema)` to create a new message.
 */
export const CreateNativeCategoryResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 137);

/**
 * Describes the message lease.merchant.v1.UpdateNativeCategoryRequest.
 * Use `create(UpdateNativeCategoryRequestSchema)` to create a new message.
 */
export const UpdateNativeCategoryRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 138);

/**
 * Describes the message lease.merchant.v1.UpdateNativeCategoryResponse.
 * Use `create(UpdateNativeCategoryResponseSchema)` to create a new message.
 */
export const UpdateNativeCategoryResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 139);

/**
 * Describes the message lease.merchant.v1.DeleteNativeCategoryRequest.
 * Use `create(DeleteNativeCategoryRequestSchema)` to create a new message.
 */
export const DeleteNativeCategoryRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 140);

/**
 * Describes the message lease.merchant.v1.DeleteNativeCategoryResponse.
 * Use `create(DeleteNativeCategoryResponseSchema)` to create a new message.
 */
export const DeleteNativeCategoryResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 141);

/**
 * Describes the message lease.merchant.v1.CreateNativeVariantRequest.
 * Use `create(CreateNativeVariantRequestSchema)` to create a new message.
 */
export const CreateNativeVariantRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 142);

/**
 * Describes the message lease.merchant.v1.CreateNativeVariantResponse.
 * Use `create(CreateNativeVariantResponseSchema)` to create a new message.
 */
export const CreateNativeVariantResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 143);

/**
 * Describes the message lease.merchant.v1.UpdateNativeVariantRequest.
 * Use `create(UpdateNativeVariantRequestSchema)` to create a new message.
 */
export const UpdateNativeVariantRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 144);

/**
 * Describes the message lease.merchant.v1.UpdateNativeVariantResponse.
 * Use `create(UpdateNativeVariantResponseSchema)` to create a new message.
 */
export const UpdateNativeVariantResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 145);

/**
 * Describes the message lease.merchant.v1.DeleteNativeVariantRequest.
 * Use `create(DeleteNativeVariantRequestSchema)` to create a new message.
 */
export const DeleteNativeVariantRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 146);

/**
 * Describes the message lease.merchant.v1.DeleteNativeVariantResponse.
 * Use `create(DeleteNativeVariantResponseSchema)` to create a new message.
 */
export const DeleteNativeVariantResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 147);

/**
 * Describes the message lease.merchant.v1.MachineVariantConfig.
 * Use `create(MachineVariantConfigSchema)` to create a new message.
 */
export const MachineVariantConfigSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 148);

/**
 * Describes the message lease.merchant.v1.GetMachineVariantConfigsRequest.
 * Use `create(GetMachineVariantConfigsRequestSchema)` to create a new message.
 */
export const GetMachineVariantConfigsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 149);

/**
 * Describes the message lease.merchant.v1.GetMachineVariantConfigsResponse.
 * Use `create(GetMachineVariantConfigsResponseSchema)` to create a new message.
 */
export const GetMachineVariantConfigsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 150);

/**
 * Describes the message lease.merchant.v1.UpdateMachineVariantConfigsRequest.
 * Use `create(UpdateMachineVariantConfigsRequestSchema)` to create a new message.
 */
export const UpdateMachineVariantConfigsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 151);

/**
 * Describes the message lease.merchant.v1.UpdateMachineVariantConfigsResponse.
 * Use `create(UpdateMachineVariantConfigsResponseSchema)` to create a new message.
 */
export const UpdateMachineVariantConfigsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 152);

/**
 * Describes the message lease.merchant.v1.SwitchOrganizationRequest.
 * Use `create(SwitchOrganizationRequestSchema)` to create a new message.
 */
export const SwitchOrganizationRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 153);

/**
 * Describes the message lease.merchant.v1.SwitchOrganizationResponse.
 * Use `create(SwitchOrganizationResponseSchema)` to create a new message.
 */
export const SwitchOrganizationResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 154);

/**
 * Describes the message lease.merchant.v1.ListMyOrganizationsRequest.
 * Use `create(ListMyOrganizationsRequestSchema)` to create a new message.
 */
export const ListMyOrganizationsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 155);

/**
 * Describes the message lease.merchant.v1.ListMyOrganizationsResponse.
 * Use `create(ListMyOrganizationsResponseSchema)` to create a new message.
 */
export const ListMyOrganizationsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 156);

/**
 * Describes the message lease.merchant.v1.RemoveUserRequest.
 * Use `create(RemoveUserRequestSchema)` to create a new message.
 */
export const RemoveUserRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 157);

/**
 * Describes the message lease.merchant.v1.RemoveUserResponse.
 * Use `create(RemoveUserResponseSchema)` to create a new message.
 */
export const RemoveUserResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 158);

/**
 * Describes the enum lease.merchant.v1.TrackableItemState.
 */
export const TrackableItemStateSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 0);

/**
 * @generated from enum lease.merchant.v1.TrackableItemState
 */
export const TrackableItemState = /*@__PURE__*/
  tsEnum(TrackableItemStateSchema);

/**
 * Describes the enum lease.merchant.v1.OrderStatus.
 */
export const OrderStatusSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 1);

/**
 * @generated from enum lease.merchant.v1.OrderStatus
 */
export const OrderStatus = /*@__PURE__*/
  tsEnum(OrderStatusSchema);

/**
 * Describes the enum lease.merchant.v1.NayaxCapturePolicy.
 */
export const NayaxCapturePolicySchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 2);

/**
 * NayaxCapturePolicy defines the server-side capture strategy for Nayax-enabled machines.
 * Applied only when payment_device_type is "nayax" and nayax_marshal_enabled is true.
 *
 * @generated from enum lease.merchant.v1.NayaxCapturePolicy
 */
export const NayaxCapturePolicy = /*@__PURE__*/
  tsEnum(NayaxCapturePolicySchema);

/**
 * Describes the enum lease.merchant.v1.NayaxCaptureStatus.
 */
export const NayaxCaptureStatusSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 3);

/**
 * NayaxCaptureStatus tracks the settlement state of a Nayax pre-authorized transaction.
 *
 * @generated from enum lease.merchant.v1.NayaxCaptureStatus
 */
export const NayaxCaptureStatus = /*@__PURE__*/
  tsEnum(NayaxCaptureStatusSchema);

/**
 * Describes the enum lease.merchant.v1.NayaxPaymentState.
 */
export const NayaxPaymentStateSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 4);

/**
 * NayaxPaymentState tracks the granular 9-state Nayax payment lifecycle.
 * This is the source-of-truth state for Nayax settlement workflows.
 *
 * @generated from enum lease.merchant.v1.NayaxPaymentState
 */
export const NayaxPaymentState = /*@__PURE__*/
  tsEnum(NayaxPaymentStateSchema);

/**
 * Describes the enum lease.merchant.v1.NotifyCustomerToCloseDoorMethod.
 */
export const NotifyCustomerToCloseDoorMethodSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 5);

/**
 * @generated from enum lease.merchant.v1.NotifyCustomerToCloseDoorMethod
 */
export const NotifyCustomerToCloseDoorMethod = /*@__PURE__*/
  tsEnum(NotifyCustomerToCloseDoorMethodSchema);

/**
 * Describes the enum lease.merchant.v1.UserStatus.
 */
export const UserStatusSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 6);

/**
 * UserStatus defines the status of an admin user account
 *
 * @generated from enum lease.merchant.v1.UserStatus
 */
export const UserStatus = /*@__PURE__*/
  tsEnum(UserStatusSchema);

/**
 * Describes the enum lease.merchant.v1.EventType.
 */
export const EventTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 7);

/**
 * @generated from enum lease.merchant.v1.EventType
 */
export const EventType = /*@__PURE__*/
  tsEnum(EventTypeSchema);

/**
 * Describes the enum lease.merchant.v1.VenueAccessCodeValidationType.
 */
export const VenueAccessCodeValidationTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 8);

/**
 * VenueAccessCodeValidationType defines how venue access codes are validated
 *
 * @generated from enum lease.merchant.v1.VenueAccessCodeValidationType
 */
export const VenueAccessCodeValidationType = /*@__PURE__*/
  tsEnum(VenueAccessCodeValidationTypeSchema);

/**
 * Describes the enum lease.merchant.v1.VenueAccessCodeCharacterType.
 */
export const VenueAccessCodeCharacterTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 9);

/**
 * VenueAccessCodeCharacterType defines allowed characters in venue access codes
 *
 * @generated from enum lease.merchant.v1.VenueAccessCodeCharacterType
 */
export const VenueAccessCodeCharacterType = /*@__PURE__*/
  tsEnum(VenueAccessCodeCharacterTypeSchema);

/**
 * Describes the enum lease.merchant.v1.ActuatorType.
 */
export const ActuatorTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 10);

/**
 * ActuatorType represents the type of actuator/slave device
 *
 * @generated from enum lease.merchant.v1.ActuatorType
 */
export const ActuatorType = /*@__PURE__*/
  tsEnum(ActuatorTypeSchema);

/**
 * Describes the enum lease.merchant.v1.VirtualProductMode.
 */
export const VirtualProductModeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 11);

/**
 * VirtualProductMode defines how virtual products are sourced for an organization.
 *
 * @generated from enum lease.merchant.v1.VirtualProductMode
 */
export const VirtualProductMode = /*@__PURE__*/
  tsEnum(VirtualProductModeSchema);

/**
 * @generated from service lease.merchant.v1.AuthService
 */
export const AuthService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 0);

/**
 * @generated from service lease.merchant.v1.CustomerService
 */
export const CustomerService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 1);

/**
 * @generated from service lease.merchant.v1.ProductService
 */
export const ProductService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 2);

/**
 * @generated from service lease.merchant.v1.MachineService
 */
export const MachineService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 3);

/**
 * @generated from service lease.merchant.v1.OrderService
 */
export const OrderService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 4);

/**
 * @generated from service lease.merchant.v1.OrganizationService
 */
export const OrganizationService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 5);

/**
 * @generated from service lease.merchant.v1.VenueAccessCodeService
 */
export const VenueAccessCodeService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 6);

/**
 * @generated from service lease.merchant.v1.UserService
 */
export const UserService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 7);

/**
 * @generated from service lease.merchant.v1.AuditLogService
 */
export const AuditLogService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 8);

/**
 * @generated from service lease.merchant.v1.S3Service
 */
export const S3Service = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 9);

/**
 * VirtualProductManagementService provides admin RPCs for managing
 * virtual product integration (external API and native portal products).
 *
 * --- External API mode ---
 *
 * @generated from service lease.merchant.v1.VirtualProductManagementService
 */
export const VirtualProductManagementService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 10);

